import { HeroUIProvider } from "@heroui/react";
import { Outlet, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";

export function BaseLayout({ children }: { children?: React.ReactNode }) {
  const navigate = useNavigate();

  return (
    <>
      <HeroUIProvider navigate={navigate}>
        <main id="main" className={`bg-background text-foreground`}>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="dark"
          />
          <>{children || <Outlet />}</>
        </main>
      </HeroUIProvider>
    </>
  );
}
